import { Util } from '@leverege/api-attributes'

import Factory from './Factory.jsx'
import { AttributeTree } from '~/reducers'

function createPathValidator( attributeTreeParentNode, attributes, currentItem ) {
  return ( name ) => {
    if ( name === 'id' || name === 'systemId' ) {
      return false
    }
    if ( attributeTreeParentNode == null ) { 
      return Util.isPathValid( name )
    }
    let tname
    if ( attributeTreeParentNode.path === '' ) {
      tname = name
    } else {
      tname = `${attributeTreeParentNode.path}/${name}`
    }
    if ( tname.length > 500 || !Util.isPathValid( name ) ) { // /^[a-zA-Z0-9_\/]+$/.test( tname )
      return false
    }

    const c = AttributeTree.findNodeByPath( attributeTreeParentNode, name );
    if ( c != null && c !== currentItem ) {
      return false
    }

    return !AttributeTree.hasConflict( attributes || [], tname, currentItem )
  }
}

function keyValidator( evt ) {
  const inp = String.fromCharCode( evt.charCode );
  const c = evt.charCode;
  if ( /[a-zA-Z0-9_*@]/.test( inp ) ) {
    return true;
  }
  return false;
}

function keyPathValidator( evt ) {
  const inp = String.fromCharCode( evt.charCode );
  const c = evt.charCode;
  if ( /^[a-zA-Z0-9_/*@]+$/.test( inp ) ) {
    return true;
  }
  return false;
}

module.exports = {
  Factory,
  EventKeyValidator : keyValidator, // Disallow '/'
  EventKeyPathValidator : keyPathValidator, // Allow '/'
  createPathValidator
}
